<template>
	<div id="Calculator">
		<h3>Calculator</h3>
		<div class="material-wrapper">
			<div class="material-section">
				<CalculatorComponent></CalculatorComponent>
			</div>
			
		</div>
	</div>
</template>

<script>
import CalculatorComponent from './CalculatorComponent.vue'

export default {
	name:'Calculator',
	data: function() {
		return {
			status:'Checking...'
		}
	},
	computed: {
		
	},
	async mounted() {
	},
	methods: {
	},
	components: {
		CalculatorComponent
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Calculator.vue